/** Media 模式指标列 */
export const METRIC_CODES = ['audience', 'followers', 'publications', 'engagement'] as const;

/** Regions tab 使用的指标列 */
export const REGION_METRIC_CODES = ['creators', 'publications', 'engagement', 'views', 'hours_watched'] as const;

/** Streams tab 指标列（与列表接口字段一致） */
export const STREAM_METRIC_CODES = ['avg_cc_viewers', 'max_cc_viewers', 'hours_watched'] as const;

export const METRIC_NAME_EN: Record<(typeof METRIC_CODES)[number], string> = {
  audience: 'Audience',
  followers: 'Followers',
  publications: 'Publications',
  engagement: 'Engagement',
};

export const METRIC_NAME_CN: Record<(typeof METRIC_CODES)[number], string> = {
  audience: '受众规模',
  followers: '粉丝数',
  publications: '发帖数',
  engagement: '互动量',
};

export const REGION_METRIC_NAME_EN: Record<(typeof REGION_METRIC_CODES)[number], string> = {
  creators: 'Creators',
  publications: 'Publications',
  engagement: 'Engagement',
  views: 'Views',
  hours_watched: 'Hours Watched',
};

export const REGION_METRIC_NAME_CN: Record<(typeof REGION_METRIC_CODES)[number], string> = {
  creators: '创作者',
  publications: '发帖数',
  engagement: '互动量',
  views: '观看量',
  hours_watched: '观看时长',
};

export const STREAM_METRIC_NAME_EN: Record<(typeof STREAM_METRIC_CODES)[number], string> = {
  avg_cc_viewers: 'Avg CC Viewers',
  max_cc_viewers: 'Max CC Viewers',
  hours_watched: 'Hours Watched',
};

export const STREAM_METRIC_NAME_CN: Record<(typeof STREAM_METRIC_CODES)[number], string> = {
  avg_cc_viewers: '平均同时在线观众数',
  max_cc_viewers: '峰值同时在线观众数',
  hours_watched: '观看时长',
};

export const DEFAULT_METRIC_FEATURES = {
  format: 'thousandsInit' as const,
  sortable: true as const,
  downLoadFormat: '#,##0' as const,
};

export const DEFAULT_DATA_KEY = 'prMediaTable';
